import React, { Component } from 'react';
import { colors } from '../data';
import block from 'bem-cn-lite';
import Typed from './typed';
import BlinkingMarker from '../../Components/BlinkingMarker';
block.setup({
    mod: '--'
});
const b = block('Task');

class Task extends Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.marked !== this.props.marked;
    }
    render() {
        const { name, image, assignees, description, column, dragging, marked, animate } = this.props;
        return (
            <div className={b({
                dragging: dragging
            })}>
                {(marked && !dragging) && <BlinkingMarker bottom={15} right={15}/>}
                {image
                    ? <div className={b('image')}>
                          <img
                              width="200"
                              src={image}
                              alt={name}
                          />
                      </div>
                    : null}
                <div className={b('name')}>
                    {name} 
                </div>
                {description
                    ? <div className={b('description')}>
                          <Typed 
                            animate={animate} 
                            text={ description[column] || 'default' } 
                            />
                      </div>
                    : null}
                <div className={b('assignees')}>
                    {assignees.map(assignee =>
                        <div key={assignee} 
                            style={{
                                backgroundColor: colors[assignee]
                            }}
                            className={b('assignee')}>
                            {assignee}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Task;
